import { Loader } from 'src/components/core';
import { NotFound } from 'src/components/common';
import { ManagementSidebar } from './components/management-sidebar';
import { ManagementDetailPanel } from './components/management-detail-panel';
import { useQualityMetricsManagementContext } from './quality-metrics-management.context';
import styles from './quality-metrics-management.module.scss';

export function QualityMetricsManagementLayout({ onEdit }) {
  const { metrics, loading, error, lang } = useQualityMetricsManagementContext();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <NotFound />;
  }

  // An org with the feature on but no metrics yet is the normal starting state
  // here, not an error — the header's "New metric" button is the way out.
  if (!metrics.length) {
    return <p className={styles.emptyText}>{lang.NO_METRICS}</p>;
  }

  return (
    <div className={styles.layout}>
      <ManagementSidebar />
      <ManagementDetailPanel onEdit={onEdit} />
    </div>
  );
}
